export default {
  version: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js